import { createSlice } from "@reduxjs/toolkit";

const initialState= {
  cdrPlanType: '',
  cdrSettings: null,
  cdrtransid: '',
  civilID: '',
  isCdrVerification: false,
  cdrSuccessFunCall: ()=> {},
  cdrCategories: null,
  cdrCards: null,
  isVip: false,
  cdrMonths: null,
  isCdrCardsData: '',
}
export const appSlice = createSlice({
  name: "cdrData",
  initialState,
  reducers: {
    setCdrPlanType: (state, action) => {
      state.cdrPlanType = action.payload;
    },  
    setCdrSettings: (state, action) => {
      state.cdrSettings = action.payload;
    },    
    setCdrtransid: (state, action) => {
      state.cdrtransid = action.payload;
    },
    setIsCdrVerification : (state, action)=>{
      state.isCdrVerification = action.payload
    },
    setCdrCivilID : (state, action) =>{
        state.civilID = action.payload
    },
    setCdrSuccessFunCall: (state, action) =>{
        state.cdrSuccessFunCall = action.payload;
    },
    setCdrCategories: (state, action) => {
      state.cdrCategories = action.payload;
    },
    setCdrCards: (state, action) => {
      state.cdrCards = action.payload;
    },
    setIsVip:(state, action)=>{
      state.isVip = action.payload;
    },
    setCdrMonths:(state, action)=>{
      state.cdrMonths = action.payload;
    },
    setIsCdrCardsData:(state, action)=>{
      state.isCdrCardsData = action.payload;
    },
    resetCdrReduxData:() => initialState,
  },
});

export const {
  setCdrPlanType,
  setCdrSettings,
  setCdrtransid,
  setIsCdrVerification, 
  setCdrCivilID, 
  setCdrSuccessFunCall,
  setCdrCategories,
  setCdrCards, setIsVip,
  setCdrMonths,
  setIsCdrCardsData,
  resetCdrReduxData
} = appSlice.actions;
export default appSlice.reducer;
